export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  tags: string[];
  chapters: ComicChapter[];
  updatedAt: string;
}

export const categories = [
  { name: '全部漫画', slug: 'all', icon: 'ri-book-open-line' },
  { name: '爱情', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'secretarys-secret',
    title: '秘书的秘密',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20office%20setting%2C%20elegant%20woman%20in%20office%20attire%2C%20warm%20lighting%2C%20soft%20pastel%20tones%2C%20professional%20illustration%20with%20clean%20lines%2C%20webtoon%20aesthetic%2C%20emotional%20expression%2C%20cinematic%20composition%2C%20cream%20background%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '爱情',
    categorySlug: 'romance',
    description: '一位职场精英女秘书与霸道总裁之间发生的甜蜜浪漫故事。她表面冷静克制，内心却藏着不可告人的秘密。当两人之间的界限逐渐模糊，一段禁忌的办公室恋情悄然展开。',
    rating: 4.8,
    views: 1250000,
    status: '连载中',
    tags: ['办公室恋情', '霸道总裁', '职场', '甜宠'],
    chapters: [
      { id: 'c1-1', title: '第1话 初次见面', number: 1, updatedAt: '2026-06-28' },
      { id: 'c1-2', title: '第2话 秘密任务', number: 2, updatedAt: '2026-06-25' },
      { id: 'c1-3', title: '第3话 意外碰面', number: 3, updatedAt: '2026-06-22' },
      { id: 'c1-4', title: '第4话 心跳加速', number: 4, updatedAt: '2026-06-18' },
      { id: 'c1-5', title: '第5话 夜色降临', number: 5, updatedAt: '2026-06-15' },
    ],
    updatedAt: '2026-06-28',
  },
  {
    id: '2',
    slug: 'blade-of-destiny',
    title: '命运之刃',
    author: '金贤秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20warrior%20with%20sword%20in%20ancient%20Korean%20setting%2C%20martial%20arts%20action%20scene%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20traditional%20elements%2C%20epic%20atmosphere%2C%20muted%20earth%20tones%2C%20professional%20webtoon%20illustration%2C%20dynamic%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在古老帝国中，一位被遗忘的剑士继承了传说中的命运之刃。为了寻找真相与复仇，他踏上了充满危险的征程。途中遭遇各种奇遇与挑战，逐渐揭开帝国尘封的秘密。',
    rating: 4.9,
    views: 980000,
    status: '连载中',
    tags: ['玄幻', '武侠', '冒险', '热血'],
    chapters: [
      { id: 'c2-1', title: '第1话 觉醒', number: 1, updatedAt: '2026-06-27' },
      { id: 'c2-2', title: '第2话 传承', number: 2, updatedAt: '2026-06-24' },
      { id: 'c2-3', title: '第3话 初战', number: 3, updatedAt: '2026-06-20' },
    ],
    updatedAt: '2026-06-27',
  },
  {
    id: '3',
    slug: 'midnight-detective',
    title: '午夜侦探',
    author: '李东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%2C%20detective%20in%20dark%20alley%20at%20night%2C%20noir%20atmosphere%20with%20neon%20accents%2C%20mysterious%20shadowy%20figure%2C%20rainy%20urban%20setting%2C%20suspenseful%20mood%2C%20cinematic%20lighting%2C%20dark%20blue%20and%20crimson%20tones%2C%20professional%20webtoon%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '午夜时分，城市陷入沉睡，而他却开始工作。一位身手不凡的私家侦探接手一桩离奇失踪案，随着调查深入，一个庞大的地下犯罪网络逐渐浮出水面。',
    rating: 4.7,
    views: 756000,
    status: '已完结',
    tags: ['悬疑推理', '犯罪', '都市', '硬汉'],
    chapters: [
      { id: 'c3-1', title: '第1话 午夜来电', number: 1, updatedAt: '2026-05-15' },
      { id: 'c3-2', title: '第2话 失踪者', number: 2, updatedAt: '2026-05-12' },
      { id: 'c3-3', title: '第3话 线索', number: 3, updatedAt: '2026-05-08' },
      { id: 'c3-4', title: '第4话 真相', number: 4, updatedAt: '2026-05-04' },
    ],
    updatedAt: '2026-05-15',
  },
  {
    id: '4',
    slug: 'my-lovely-neighbor',
    title: '我的可爱邻居',
    author: '崔美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20cover%2C%20cute%20couple%20next%20door%20story%2C%20bright%20cheerful%20illustration%2C%20pastel%20pink%20and%20yellow%20tones%2C%20modern%20apartment%20setting%2C%20playful%20atmosphere%2C%20webtoon%20style%20with%20soft%20lines%2C%20heartwarming%20scene&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '搬到新公寓的第一天，她就遇到了隔壁那个让人又爱又恨的男人。两人的日常斗嘴与意外温馨的瞬间，编织出一段轻松搞笑的都市爱情故事。',
    rating: 4.6,
    views: 890000,
    status: '连载中',
    tags: ['恋爱喜剧', '日常', '都市', '搞笑'],
    chapters: [
      { id: 'c4-1', title: '第1话 搬家', number: 1, updatedAt: '2026-06-26' },
      { id: 'c4-2', title: '第2话 隔音太差', number: 2, updatedAt: '2026-06-23' },
    ],
    updatedAt: '2026-06-26',
  },
  {
    id: '5',
    slug: 'crown-of-thorns',
    title: '荆棘王冠',
    author: '尹雅丽',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20historical%20cover%2C%20elegant%20queen%20in%20palace%20setting%2C%20royal%20intrigue%2C%20luxurious%20traditional%20Korean%20hanbok%2C%20dramatic%20shadow%20and%20light%2C%20rich%20jewel%20tones%2C%20emotional%20expression%2C%20professional%20webtoon%20art%2C%20cinematic%20palace%20interior&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    description: '在朝鲜时代的宫廷中，一位出身卑微的女子阴差阳错成为王妃。面对后宫的重重阴谋与权力的腥风血雨，她必须学会在荆棘丛中前行，守护自己珍视的一切。',
    rating: 4.9,
    views: 1100000,
    status: '连载中',
    tags: ['宫廷', '权谋', '历史', '女性成长'],
    chapters: [
      { id: 'c5-1', title: '第1话 入宫', number: 1, updatedAt: '2026-06-28' },
      { id: 'c5-2', title: '第2话 册封', number: 2, updatedAt: '2026-06-25' },
      { id: 'c5-3', title: '第3话 阴谋', number: 3, updatedAt: '2026-06-21' },
    ],
    updatedAt: '2026-06-28',
  },
  {
    id: '6',
    slug: 'zombie-academy',
    title: '僵尸学院',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20action%20cover%2C%20students%20fighting%20zombies%20in%20school%2C%20survival%20scenario%2C%20dark%20intense%20atmosphere%2C%20muted%20green%20and%20gray%20tones%2C%20thrilling%20composition%2C%20professional%20webtoon%20illustration%2C%20dramatic%20action%20pose&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    description: '一所普通高中突然爆发僵尸病毒，被困在校内的学生们必须在生存与人性之间做出选择。紧张刺激的逃生剧情，让人屏息的每一个瞬间。',
    rating: 4.5,
    views: 670000,
    status: '已完结',
    tags: ['丧尸', '生存', '校园', '动作'],
    chapters: [
      { id: 'c6-1', title: '第1话 零号病人', number: 1, updatedAt: '2026-04-20' },
      { id: 'c6-2', title: '第2话 封锁', number: 2, updatedAt: '2026-04-17' },
      { id: 'c6-3', title: '第3话 逃亡', number: 3, updatedAt: '2026-04-13' },
    ],
    updatedAt: '2026-04-20',
  },
  {
    id: '7',
    slug: 'magic-emporium',
    title: '魔法杂货铺',
    author: '韩智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20magical%20shop%20interior%20with%20mysterious%20items%2C%20whimsical%20atmosphere%2C%20warm%20golden%20lighting%2C%20cute%20fantasy%20creatures%2C%20cozy%20vibes%2C%20pastel%20and%20warm%20tones%2C%20webtoon%20art%20style%2C%20enchanting%20scene&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在城市的隐秘角落，有一家不起眼的杂货铺。每个商品都拥有神奇的魔力，而店主其实是一位退休的大魔法师。当命运多舛的客人们推门而入，不可思议的故事就此展开。',
    rating: 4.7,
    views: 820000,
    status: '连载中',
    tags: ['治愈', '魔法', '日常奇幻', '温情'],
    chapters: [
      { id: 'c7-1', title: '第1话 有缘人', number: 1, updatedAt: '2026-06-24' },
      { id: 'c7-2', title: '第2话 许愿蜡烛', number: 2, updatedAt: '2026-06-21' },
    ],
    updatedAt: '2026-06-24',
  },
  {
    id: '8',
    slug: 'underground-fighter',
    title: '地下拳王',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20fighter%20in%20underground%20arena%2C%20intense%20boxing%20match%2C%20dramatic%20lighting%20with%20spotlight%2C%20sweat%20and%20determination%2C%20dark%20atmosphere%2C%20powerful%20muscular%20figure%2C%20professional%20webtoon%20illustration%2C%20dynamic%20action%20scene&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '曾经的天才拳手沦为地下拳场的格斗者。为了给家人筹集医药费，他不得不在每一场生死较量中拼尽全力。拳拳到肉的热血格斗，令人肾上腺素飙升。',
    rating: 4.6,
    views: 540000,
    status: '连载中',
    tags: ['格斗', '热血', '竞技', '逆袭'],
    chapters: [
      { id: 'c8-1', title: '第1话 堕落天才', number: 1, updatedAt: '2026-06-22' },
      { id: 'c8-2', title: '第2话 第一场', number: 2, updatedAt: '2026-06-19' },
      { id: 'c8-3', title: '第3话 对手', number: 3, updatedAt: '2026-06-15' },
    ],
    updatedAt: '2026-06-22',
  },
  {
    id: '9',
    slug: 'time-traveler-kim',
    title: '穿越者金某',
    author: '宋河英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20time%20traveler%20in%20both%20modern%20and%20historical%20clothing%2C%20funny%20expression%2C%20split%20composition%20between%20eras%2C%20bright%20playful%20colors%2C%20humorous%20webtoon%20style%2C%20clean%20illustration%2C%20contrasting%20backgrounds&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '一觉醒来竟然穿越到了朝鲜时代？当代废柴程序员金某凭借着自己半吊子的历史知识和现代科技，在古代朝鲜掀起了一场啼笑皆非的文化革命。',
    rating: 4.8,
    views: 1350000,
    status: '连载中',
    tags: ['穿越', '搞笑', '历史', '逆袭'],
    chapters: [
      { id: 'c9-1', title: '第1话 醒来', number: 1, updatedAt: '2026-06-28' },
      { id: 'c9-2', title: '第2话 朝鲜时代', number: 2, updatedAt: '2026-06-25' },
      { id: 'c9-3', title: '第3话 天才发明', number: 3, updatedAt: '2026-06-22' },
      { id: 'c9-4', title: '第4话 王宫', number: 4, updatedAt: '2026-06-18' },
    ],
    updatedAt: '2026-06-28',
  },
  {
    id: '10',
    slug: 'last-flower',
    title: '最后一朵花',
    author: '郑秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20sad%20woman%20holding%20a%20flower%20in%20rain%2C%20melancholic%20atmosphere%2C%20soft%20blue%20and%20gray%20tones%2C%20emotional%20illustration%2C%20delicate%20art%20style%2C%20webtoon%20aesthetic%2C%20poetic%20mood%2C%20gentle%20rainfall%20setting&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    description: '一个被命运捉弄的女子，生命中遇到的每一个人都像花朵般绽放又凋零。当最后一朵花即将凋谢，她选择用尽全力去爱，哪怕结局早已注定。',
    rating: 4.9,
    views: 720000,
    status: '已完结',
    tags: ['催泪', '人生', '治愈', '文艺'],
    chapters: [
      { id: 'c10-1', title: '第1话 花与少女', number: 1, updatedAt: '2026-03-10' },
      { id: 'c10-2', title: '第2话 春天的约定', number: 2, updatedAt: '2026-03-07' },
      { id: 'c10-3', title: '第3话 盛夏', number: 3, updatedAt: '2026-03-03' },
      { id: 'c10-4', title: '第4话 秋叶', number: 4, updatedAt: '2026-02-28' },
      { id: 'c10-5', title: '第5话 最后的冬天', number: 5, updatedAt: '2026-02-24' },
    ],
    updatedAt: '2026-03-10',
  },
  {
    id: '11',
    slug: 'shadow-agent',
    title: '暗影特工',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20spy%20cover%2C%20secret%20agent%20in%20tactical%20gear%2C%20urban%20night%20setting%2C%20espionage%20theme%2C%20dark%20moody%20atmosphere%2C%20cool%20blue%20and%20black%20tones%2C%20professional%20webtoon%20illustration%2C%20cinematic%20action%20pose&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '国家情报院最顶尖的特工，在一次任务中意外发现组织的黑暗面。被自己人追杀的他，必须在48小时内揭露真相，同时保护唯一的证人。',
    rating: 4.7,
    views: 610000,
    status: '连载中',
    tags: ['谍战', '动作', '悬疑', '硬汉'],
    chapters: [
      { id: 'c11-1', title: '第1话 任务', number: 1, updatedAt: '2026-06-20' },
      { id: 'c11-2', title: '第2话 背叛', number: 2, updatedAt: '2026-06-17' },
    ],
    updatedAt: '2026-06-20',
  },
  {
    id: '12',
    slug: 'sweet-dream-bakery',
    title: '甜梦面包店',
    author: '安孝真',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cozy%20bakery%20interior%20with%20fresh%20bread%2C%20warm%20morning%20light%2C%20cute%20baker%2C%20comforting%20atmosphere%2C%20golden%20and%20cream%20tones%2C%20heartwarming%20scene%2C%20webtoon%20style%2C%20delicate%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '爱情',
    categorySlug: 'romance',
    description: '在首尔一条安静的小巷中，一家手工面包店因独特的口味而闻名。店主是一位温柔的面包师，而每位光顾的客人都有着属于自己的故事。面包与爱情的香气交织在一起。',
    rating: 4.5,
    views: 480000,
    status: '连载中',
    tags: ['治愈', '美食', '日常生活', '温暖'],
    chapters: [
      { id: 'c12-1', title: '第1话 清晨的面包', number: 1, updatedAt: '2026-06-19' },
      { id: 'c12-2', title: '第2话 常客', number: 2, updatedAt: '2026-06-16' },
    ],
    updatedAt: '2026-06-19',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '小橘子',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20soft%20natural%20lighting%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20friendly%20expression&width=200&height=200&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '韩漫网的更新速度真的太快了！每天都能看到最新的热门韩漫，画质也很清晰，完全免费，已经推荐给身边所有喜欢看漫画的朋友了。',
  },
  {
    id: 't2',
    name: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%2C%20friendly%20expression%2C%20natural%20lighting%2C%20modern%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%2C%20warm%20tone&width=200&height=200&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '我每天上下班路上都会打开韩漫网看几话，阅读体验很流畅。分类也很齐全，爱情、奇幻、悬疑什么都有，完全满足我这个漫画爱好者的需求。',
  },
  {
    id: 't3',
    name: '星河漫游',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20woman%20portrait%2C%20bright%20smile%2C%20soft%20natural%20light%2C%20elegant%20casual%20style%2C%20clean%20minimal%20background%2C%20professional%20headshot%2C%20warm%20and%20friendly&width=200&height=200&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '从发现韩漫网到现在已经追了十几部漫画了，资源真的很丰富。最喜欢《荆棘王冠》和《穿越者金某》，每次更新都第一时间来看！',
  },
];

export const faqs = [
  {
    question: '韩漫网上的漫画都是免费的吗？',
    answer: '是的，韩漫网上的所有韩国漫画均为完全免费阅读，无需付费或订阅。我们致力于为漫画爱好者提供优质、免费的漫画阅读体验，让每一位用户都能畅享韩漫的魅力。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们与多家韩国漫画平台保持紧密合作，热门连载漫画通常每周更新一到两话，部分高人气作品可实现每日更新。您可以在每部漫画的详情页查看具体的更新计划。',
  },
  {
    question: '支持哪些设备阅读漫画？',
    answer: '韩漫网采用响应式网页设计，完美适配电脑、平板和手机等各种设备。无论在哪种设备上，您都能享受到流畅舒适的漫画在线阅读体验。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的搜索功能直接搜索漫画名称，也可以按分类（爱情、奇幻、动作、悬疑、搞笑、剧情、恐怖等）浏览。首页还有热门推荐和最新更新板块，帮助您发现更多精彩作品。',
  },
  {
    question: '漫画的画质怎么样？',
    answer: '韩漫网所有漫画均为高清画质，保证每一页漫画的细节都清晰可见。我们持续优化图片加载技术，在保证画质的同时提供快速的加载体验。',
  },
  {
    question: '可以下载漫画离线阅读吗？',
    answer: '目前韩漫网支持在线实时阅读。为了获得最佳阅读体验和最新内容，建议您在线浏览。我们正在开发离线阅读功能，敬请期待。',
  },
];